import { Button, Form, Input, InputNumber, Select, Space } from "@arco-design/web-react";
import { useEffect, useState } from "react";
import { copy } from "../utils/copy";
import { IconCopy } from "@arco-design/web-react/icon";
import { toHValue } from "../utils/wrap";

const Option = Select.Option;
const FormItem = Form.Item;
const LinearSpeedCalculation = () => {
  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const STORAGE_KEY = "tac_values_v1";
  const loadSaved = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };
  const save = (data) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  };
  const parseNum = (v) => (v === undefined || v === null || v === "" ? NaN : Number(v));
  const calculate = () => {
    switch (current) {
      case 0:
        const { x0, a0 } = form.getFieldsValue();
        form.setFieldValue("z0", toHValue((Math.tan((a0 * Math.PI) / 180) * x0) / 2));
        break;
      case 1:
        const { z1, a1 } = form.getFieldsValue();
        form.setFieldValue("x1", toHValue((2 * z1) / Math.tan((a1 * Math.PI) / 180)));
        break;
      case 2:
        const { d1, d2, a2, zd2, xd2: formXd2 } = form.getFieldsValue();
        const nd1 = parseNum(d1);
        const nd2 = parseNum(d2);
        let xd2Val = formXd2;
        if (!isNaN(nd1) && !isNaN(nd2)) {
          xd2Val = nd1 - nd2; // X' = D1 - D2
          form.setFieldValue("xd2", toHValue(xd2Val));
        }
        const nXd2 = parseNum(xd2Val);
        const nA2 = parseNum(a2);
        const nZd2 = parseNum(zd2);
        form.setFieldValue("z2", toHValue(nZd2 + (nXd2 / 2) * Math.tan((nA2 * Math.PI) / 180)));
        form.setFieldValue("x2", toHValue(nXd2 / Math.cos((nA2 * Math.PI) / 180)));
        break;
      default:
        break;
    }
    // persist after calculation
    save({ current, values: form.getFieldsValue() });
  };
  const options = [
    { name: "已知修整量 X，角度θ，求修整量 Z", value: 0 },
    { name: "已知修整量 Z，角度θ，求修整量 X", value: 1 },
    { name: "已知图纸直径差 X'，角度θ，长度图纸 Z'", value: 2 },
  ];

  const onChange = (value) => {
    setCurrent(value);
    const values = form.getFieldsValue();
    save({ current: value, values });
  };
  useEffect(() => {
    const saved = loadSaved();
    if (saved) {
      if (typeof saved.current === "number") setCurrent(saved.current);
      if (saved.values) form.setFieldsValue(saved.values);
    }
  }, []);
  return (
    <div className="cpn-wrapper-horizontal">
      <Form
        style={{ maxWidth: 500, width: "90%" }}
        autoComplete="off"
        form={form}
        colon=":"
        onValuesChange={(changeValue, allValues) => {
          if (current === 2) {
            const changedKey = Object.keys(changeValue || {})[0];
            if (changedKey === "d1" || changedKey === "d2") {
              const nd1 = parseNum(allValues.d1);
              const nd2 = parseNum(allValues.d2);
              if (!isNaN(nd1) && !isNaN(nd2)) {
                form.setFieldValue("xd2", toHValue(nd1 - nd2));
              }
            }
          }
          // persist on any change
          save({ current, values: allValues });
        }}
        onSubmit={calculate}
        layout={document.body.clientWidth <= 780 ? "vertical" : "horizontal"}
      >
        <FormItem label="类型" field="type">
          <Select
            size="large"
            placeholder="请选择已知条件"
            onChange={onChange}
            value={0} // 不生效
          >
            {options.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.name}
              </Option>
            ))}
          </Select>
        </FormItem>
        {current === 0 && (
          <>
            <FormItem
              label="修整量X"
              field="x0"
              rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
            >
              <InputNumber min="0" size="large" />
            </FormItem>
            <FormItem
              label="角度θ"
              field="a0"
              rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
            >
              <InputNumber min="0" size="large" />
            </FormItem>
          </>
        )}
        {current === 1 && (
          <>
            <FormItem
              label="修整量Z"
              field="z1"
              rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
            >
              <InputNumber min="0" size="large" />
            </FormItem>
            <FormItem
              label="角度θ"
              field="a1"
              rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
            >
              <InputNumber min="0" size="large" />
            </FormItem>
          </>
        )}
        {current === 2 && (
          <>
            <FormItem
              label="台阶1直径D1"
              field="d1"
              rules={[{
                validator: (value, cb) =>
                  value === undefined || value === null || value === "" || value > 0
                    ? cb()
                    : cb("需大于 0!")
              }]}
            >
              <InputNumber min="0" size="large" />
            </FormItem>
            <FormItem
              label="台阶2直径D2"
              field="d2"
              rules={[{
                validator: (value, cb) =>
                  value === undefined || value === null || value === "" || value > 0
                    ? cb()
                    : cb("需大于 0!")
              }]}
            >
              <InputNumber min="0" size="large" />
            </FormItem>
            <FormItem label="图纸直径差X'" field="xd2">
              <Input
                size="large"
                id="result_tac_xd2"
                onClick={copy}
                placeholder="可输入或自动计算"
                suffix={<IconCopy onClick={copy.bind(this, null, "#result_tac_xd2")} style={{ cursor: "pointer" }} />}
              />
            </FormItem>
            <FormItem
              label="角度θ"
              field="a2"
              rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
            >
              <InputNumber min="0" size="large" />
            </FormItem>
            <FormItem
              label="长度图纸Z'"
              field="zd2"
              rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
            >
              <InputNumber min="0" size="large" />
            </FormItem>
          </>
        )}
        <FormItem wrapperCol={{ offset: 5 }}>
          <Space>
            <Button type="primary" htmlType="submit">
              立即计算
            </Button>
            <Button
              onClick={() => {
                form.resetFields();
                localStorage.removeItem(STORAGE_KEY);
              }}
            >
              重置
            </Button>
          </Space>
        </FormItem>
        {current === 0 && (
          <FormItem label="修整量Z" field="z0">
            <Input
              size="large"
              id="result_tac_z0"
              readOnly
              onClick={copy}
              placeholder="计算结果在此次显示"
              suffix={<IconCopy onClick={copy.bind(this, null, "#result_tac_z0")} style={{ cursor: "pointer" }} />}
            />
          </FormItem>
        )}
        {current === 1 && (
          <FormItem label="修整量X" field="x1">
            <Input
              size="large"
              id="result_tac_x1"
              readOnly
              onClick={copy}
              placeholder="计算结果在此次显示"
              suffix={<IconCopy onClick={copy.bind(this, null, "#result_tac_x1")} style={{ cursor: "pointer" }} />}
            />
          </FormItem>
        )}
        {current === 2 && (
          <>
            <FormItem label="长度程序Z" field="z2">
              <Input
                size="large"
                id="result_tac_z2"
                readOnly
                onClick={copy}
                placeholder="计算结果在此次显示"
                suffix={<IconCopy onClick={copy.bind(this, null, "#result_tac_z2")} style={{ cursor: "pointer" }} />}
              />
            </FormItem>
            <FormItem label="西门子程序直径差X" field="x2">
              <Input
                size="large"
                id="result_tac_x2"
                readOnly
                onClick={copy}
                placeholder="计算结果在此次显示"
                suffix={<IconCopy onClick={copy.bind(this, null, "#result_tac_x2")} style={{ cursor: "pointer" }} />}
              />
            </FormItem>
          </>
        )}
      </Form>
    </div>
  );
};
export default LinearSpeedCalculation;
